export default __webpack_public_path__ + "static/media/contact_back.d458b663.jpg";